// extracted by mini-css-extract-plugin
export var sliderRange = "_dn-2";
export var sliderRoot = "_dn-0";
export var sliderThumb = "_dn-3";
export var sliderTrack = "_dn-1";